module.exports = __webpack_public_path__ + "img/outcome_2.73f74af5.gif";